const data = {
  'Selected': 'Seçilib: {0} / {1}',
  'Uploading files': 'Yüklənir: {0}% / {1}',
  'File size error': '{0} çox böyükdür, zəhmət olmasa, ölçüsü {1} həddindən kiçik olan faylları yükləyin',
  'Upload failed': '{0} yüklənə bilmədi',
  'Upload summary': '{0} uğurlu, {1} uğursuz, {2} cəmi',
  'Per page': '{0} hər səhifədə',
  'Folder': 'Qovluq',
  'Login failed, please try again': 'Daxil olmaq mümkün olmadı, zəhmət olmasa, yenidən cəhd edin',
  'Already logged in': 'Artıq daxil olmusunuz.',
  'Please enter username and password': 'Zəhmət olmasa, istifadəçi adını və parolu daxil edin.',
  'Not Found': 'Tapılmadı',
  'Not Allowed': 'İcazə verilmir',
  'Please log in': 'Zəhmət olmasa, daxil olun',
  'Unknown error': 'Naməlum xəta',
  'Add files': 'Fayllar əlavə et',
  'New': 'Yeni',
  'New name': 'Yeni ad',
  'Username': 'İstifadəçi adı',
  'Password': 'Parol',
  'Login': 'Daxil ol',
  'Logout': 'Çıxış',
  'Profile': 'Profil',
  'No pagination': 'Səhifələrə bölünmədən',
  'Time': 'Vaxt',
  'Name': 'Ad',
  'Size': 'Ölçü',
  'Home': 'Əsas səhifə',
  'Copy': 'Kopyala',
  'Move': 'Köçür',
  'Rename': 'Adını dəyiş',
  'Required': 'Zəhmət olmasa, bu sahəni doldurun',
  'Zip': 'Arxivləşdir',
  'Batch Download': 'Toplu endir',
  'Unzip': 'Arxivdən çıxar',
  'Delete': 'Sil',
  'Download': 'Endir',
  'Copy link': 'Keçidi kopyala',
  'Done': 'Hazırdır',
  'File': 'Fayl',
  'Drop files to upload': 'Yükləmək üçün faylları buraxın',
  'Close': 'Bağla',
  'Select Folder': 'Qovluq seç',
  'Users': 'İstifadəçilər',
  'Files': 'Fayllar',
  'Role': 'Rol',
  'Cancel': 'Ləğv et',
  'Paused': 'Dayandırılıb',
  'Confirm': 'Təsdiq et',
  'Create': 'Yarat',
  'User': 'İstifadəçi',
  'Admin': 'Administrator',
  'Save': 'Saxla',
  'Read': 'Oxu',
  'Write': 'Yaz',
  'Upload': 'Yüklə',
  'Permissions': 'İcazələr',
  'Homedir': 'Əsas qovluq',
  'Leave blank for no change': 'Dəyişiklik etməmək üçün boş saxlayın',
  'Are you sure you want to do this?': 'Bunu etmək istədiyinizə əminsiniz?',
  'Are you sure you want to allow access to everyone?': 'Hər kəsə giriş icazəsi vermək istədiyinizə əminsiniz?',
  'Are you sure you want to stop all uploads?': 'Bütün yükləmələri dayandırmaq istədiyinizə əminsiniz?',
  'Something went wrong': 'Xəta baş verdi',
  'Invalid directory': 'Etibarsız qovluq',
  'This field is required': 'Bu sahə mütləqdir',
  'Username already taken': 'İstifadəçi adı artıq tutulub',
  'User not found': 'İstifadəçi tapılmadı',
  'Old password': 'Köhnə parol',
  'New password': 'Yeni parol',
  'Wrong password': 'Parol yanlışdır',
  'Updated': 'Yeniləndi',
  'Deleted': 'Silindi',
  'Your file is ready': 'Faylınız hazırdır',
  'View': 'Bax',
  'Search': 'Axtarış',
  'Download permission': 'Endir',
  'Guest': 'Qonaq',
  'Show hidden': 'Gizli faylları göstər',
  'Show symbolic format': 'Simvolik formatı göstər',
  'Hide symbolic format': 'Simvolik formatı gizlət',
}

export default data
